import ajax from '../utils/ajax'

export default {
    words: (type, word) => ajax.post('/api/auto/words', {type, word}),
};
